module.exports = __webpack_public_path__ + "img/arrowRight.1a530593.svg";